



const cyoDetailApiService = (vuexContext) => ({
    async requestDiamondForDetailPage(data) {
        // console.log(data, 'datadatadatadata')
        const queryPath = data.moduleSubType === 'earring' ? '/diamond/loose-pair/detail/' : '/diamond/detail/'

        const config = useRuntimeConfig()
        // console.log('data', queryPath)

        let query_params = ''
        if (data.moduleType == 'cyo') {
            query_params = '?module_type=cyo'
        }

        const url = useCountryPath(queryPath + data.slug + query_params)


        return url
        return await this.requestProductDetailApi(data, url)

    },


    async setSettingForDetailPage(data) {

        const config = useRuntimeConfig()

        // console.log('data', data)

        const url = useCountryPath('/config/setting/' + data.moduleSubType + '/detail/' + data.slug)
        return url
        return await this.requestProductDetailApi(data, url)
    },

});

export default cyoDetailApiService;